/**
 * OVERRIDE SearchDetails.jsx
 * REASON: Special template for displaying this component, use h2 instead of h4
 */

import SearchDetails from '../../../../../../../components/Blocks/Search/components/SearchDetails';

export default SearchDetails;
